<template>
	<div class='s-block'>
		<div>
			<span class='label'>Площадь, га</span>
		</div>
		<div>
			<div class='main-s-block s-block' v-if='lpo_s'>
				<span class='auto-s-span' :class='{ "not-active": lpo_s_manual }'>{{ lpo_s }} га (автоматически из координат)</span>
			</div>
		</div>

		<div>

			<div v-if='!lpo_s_manual'>
				<button @click='enable' :disabled='!actLpoIsDraft'>Установить вручную</button>
				<div class='input-block flex-container' v-if='inputMode'>
					<input v-model='s' class='flex-item' type='number'>
					<button @click='save'>Сохранить</button>
					<button @click='disable' class='right-btn'>Закрыть</button>
				</div>
			</div>

			<div v-else class='main-s-block s-block'>
				<span>{{ lpo_s_manual }} га (установлено вручную)</span>
				<button @click='enable' :disabled='!actLpoIsDraft'>Редактировать</button>
				<button @click='clear' :disabled='!actLpoIsDraft' class='right-btn'>Удалить</button>

				<div class='input-block flex-container' v-if='inputMode'>
					<input v-model='s' class='flex-item' type='number'>
					<button @click='save'>Сохранить</button>
					<button @click='disable' class='right-btn'>Закрыть</button>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex';

	export default {
		name: 'InspectionTypeGeometrySBlock',
		data: () => ({
			s: null,

			inputMode: false
		}),
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},
			lpo_s() {
				return this.lpo.s_lp;
			},
			lpo_s_calc() {
				return this.lpo.s_lp_calc;
			},

			lpo_s_manual() {
				return this.lpo.s_lp_manual;
			}
		},
		
		methods: {
			enable() {
				this.inputMode = true;
			},
			disable() {
				this.inputMode = false;
			},

			save() {
				if (this.s === '' || this.s === null) {
					this.$toast.open({
						message: 'Нужно ввести значение площади',
						type: 'warning'
					});
					return;
				}

				this.saveS(this.s).then(res => {
					this.updateLpo();
					this.disable();
				});
			},

			clear() {
				this.clearS().then(res => {
					this.updateLpo();
				});
			},

			...mapActions('selectedLpo', [
				'saveS',
				'clearS',
				'updateLpo'
			])
		}
	};
</script>

<style scoped src='@/style/flex.css'></style>

<style scoped>
	.label {
		font-weight: bold;
	}

	.input-block {
		border: 1px solid #aaa;
		padding: 10px;
	}

	.s-block {
		font-size: 1rem;
		margin: 10px;
	}

	.calc-block {
		color: #999;
	}

	.right-btn {
		margin-left: 4px;
	}

	.auto-s-span.not-active {
		color: #bbb;
	}
</style>